module.exports = new __parcel__URL__("fire-cover.f0f94f02.png").toString();